import React, { Component } from 'react';
import { ButtonToolbar, Button, FormGroup, ControlLabel, Grid, Row, Col, Table, Panel, FormControl, Radio, Tabs, Tab } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { Notes } from '../native/tabs/Notes';
import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { LinesCommand } from '../../commands/LinesCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';
import { SetOfDayTypesCommand } from '../../../genericLayoutConfigurations/commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';
import { ProviderSelectionsCommand } from '../../commands/ProviderSelectionsCommand';
import { LayoutCommand } from '../../../genericLayoutConfigurations/commands/LayoutCommand';
import { LayoutFolderCommand } from '../../../genericLayoutConfigurations/commands/LayoutFolderCommand';
import { DownloadCommand } from '../../../files/commands/DownloadCommand';
import { ScheduleGeneratorBase } from '../common/ScheduleGeneratorBase';

import ColumnResize from "react-table-column-resizer";

export class CarrisScheduleGenerator extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    baseGenerator = new ScheduleGeneratorBase();

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            data: {
                lines: [],
                stops: [],
                layouts: [],
                folders: [],
                carrisSchedules: [],
                schedules: [],
                setOfDayTypes: [],
            },
            providerSelections: {
                data: {
                    line: "",
                    layout: "",
                    stopsSched: true,
                    lineSched: false,
                    scheduleGenerationSelections: [],
                    complementaryLines: [],
                    schedules: [],
                    frequency: undefined,
                    version: ""
                },
                search: true
            },
            validations: {
                schedulesComponents: [
                    "DayTimesheet",
                    "DayVerticalTimesheet",
                    "CompactDayTimesheet",
                    "VerticalDayTimesheet",
                    "HorizontalTabularDayTimesheet",
                    "VerticalTabularDayTimesheet",
                    "VerticalComposedDayTimesheet",
                    "PassingIntervals"
                ]
            },
            form: {
                line: undefined,
                stops: [],
                schedules: {},
                referenceDate: new Date().toISOString(),
                hideLoopsChk: true,
                type: 1,
                colorType: 1,
                frequency: undefined,
                documentDate: new Date().toISOString(),
                version: ""
            },
            render: {
                tab: 1,
                schedules: [],
                layouts: [],
                layoutsGrouped: [],
                schedulesComponents: [],
                notesComponents: [],
                setOfDayTypes: [],
                alternativeText: {},
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            commands: {
                lines: new LinesCommand(),
                stops: new PathStopsCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand(),
                providerSelections: new ProviderSelectionsCommand(),
                layouts: new LayoutCommand("bussched"),
                layoutFolders: new LayoutFolderCommand("bussched"),
                download: new DownloadCommand()
            },
            actions: {
                isLoadingEdition: true,
                isLoadingLines: true,
                isLoadingSchedules: true,
                isLoadingSetOfDayTypes: true,
                isLoadingStops: true,
                isGenerating: false,
                isDownloadingMultipleDocuments: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);

        var edition = this.context.getOwnEdition();
        edition.addObserver(this);
        edition.updateSync(new Date());

        this.setState({ edition: edition }, function() {
            this.getProviderSelections();

            this.baseGenerator.getSetOfDayTypes(
                this.state,
                function(result) { this.onDataLoaded("setOfDayTypes", "isLoadingSetOfDayTypes", result); }.bind(this),
                function(err) { this.onDataError("setOfDayTypes", "isLoadingSetOfDayTypes", err); }.bind(this)
            );

            this.baseGenerator.getLayouts(
                this.state,
                function(result) {
                    this.onDataLoaded("layouts", "isLoadingLayouts", result, function() {
                        // Prepend the hardcoded legacy layout
                        this.setState(function(prevState) {
                            var layouts = [{ id: -1, name: "Horário InfoPub Legacy" }].concat(prevState.data.layouts);
                            var layoutsGrouped = this.baseGenerator.groupLayoutsByFolder(layouts, prevState.data.folders);
                            return {
                                data: Object.assign({}, prevState.data, { layouts: layouts }),
                                render: Object.assign({}, prevState.render, { layouts: layouts, layoutsGrouped: layoutsGrouped })
                            };
                        }.bind(this));
                    }.bind(this));
                }.bind(this),
                function(err) { this.onDataError("layouts", "isLoadingLayouts", err); }.bind(this)
            );

            this.baseGenerator.getFolders(
                this.state,
                function(folders) {
                    this.setState(function(prevState) {
                        var layoutsGrouped = this.baseGenerator.groupLayoutsByFolder(prevState.data.layouts, folders);
                        return {
                            data: Object.assign({}, prevState.data, { folders: folders }),
                            render: Object.assign({}, prevState.render, { layoutsGrouped: layoutsGrouped })
                        };
                    }.bind(this));
                }.bind(this),
                function() {}
            );
        }.bind(this));
    }

    // Edition observer callbacks
    // ----------------------

    startUpdate() {
        this.setState(function(prevState) {
            return { actions: Object.assign({}, prevState.actions, { isLoadingEdition: true }) };
        });
    }

    endUpdate() {
        this.setState(function(prevState) {
            return { actions: Object.assign({}, prevState.actions, { isLoadingEdition: false }) };
        });
    }

    updateNetwork() {
        this.setState(
            function(prevState) {
                return {
                    form: Object.assign({}, prevState.form, { line: undefined }),
                    actions: Object.assign({}, prevState.actions, { isLoadingLines: true })
                };
            },
            function() {
                this.baseGenerator.getLines(
                    this.state,
                    function(result) {
                        this.onDataLoaded("lines", "isLoadingLines", result, function() {
                            this.onLinesReady();
                        }.bind(this));
                    }.bind(this),
                    function(err) { this.onDataError("lines", "isLoadingLines", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    updatePlanning() {
        this.setState(
            function(prevState) {
                return {
                    actions: Object.assign({}, prevState.actions, { isLoadingSchedules: true }),
                    render: Object.assign({}, prevState.render, { schedules: [] })
                };
            },
            function() {
                this.state.commands.schedules.listCarris(
                    this.state.edition.planning,
                    function(result) {
                        this.onDataLoaded("carrisSchedules", "isLoadingSchedules", result, function() {
                            this.applyFilteredSchedules();
                        }.bind(this));
                    }.bind(this),
                    function(err) { this.onDataError("carrisSchedules", "isLoadingSchedules", err); }.bind(this)
                );

                this.baseGenerator.getSchedules(
                    this.state,
                    function(result) { this.onDataLoaded("schedules", "isLoadingSchedules", result); }.bind(this),
                    function(err) { this.onDataError("schedules", "isLoadingSchedules", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    // Data loading
    // ----------------------

    onDataLoaded(dataType, loadingFlag, result, afterCallback) {
        this.setState(
            function(prevState) {
                var newData = Object.assign({}, prevState.data);
                newData[dataType] = result;
                var newActions = Object.assign({}, prevState.actions);
                newActions[loadingFlag] = false;
                return { data: newData, actions: newActions };
            },
            function() {
                if (typeof afterCallback === "function") {
                    afterCallback();
                } else {
                    this.setState(function(prevState) {
                        var layoutState = this.baseGenerator.computeLayoutSelected(prevState);
                        var merged = Object.assign({}, prevState, layoutState);
                        var selectionState = this.baseGenerator.computeSelectionExists(merged, false);
                        return selectionState
                            ? Object.assign({}, layoutState, selectionState)
                            : layoutState;
                    }.bind(this));
                }
            }.bind(this)
        );
    }

    onDataError(dataType, loadingFlag, message) {
        this.setState(function(prevState) {
            var newData = Object.assign({}, prevState.data);
            newData[dataType] = [];
            var newActions = Object.assign({}, prevState.actions);
            newActions[loadingFlag] = false;
            var msg = prevState.message.show
                ? prevState.message.message + "\n" + message
                : message;
            return {
                data: newData,
                actions: newActions,
                message: { show: true, message: msg, style: "danger", title: "Erro", icon: "remove" }
            };
        });
    }

    // Provider selections
    // ----------------------

    getProviderSelections() {
        this.state.commands.providerSelections.get(
            function(result) { this.onProviderSelectionsLoaded(result); }.bind(this)
        );
    }

    onProviderSelectionsLoaded(result) {
        if (result == null) return;

        if (result.layout === undefined) {
            result.layout = { id: -1, name: "Horário InfoPub Legacy" };
        }

        this.setState(
            function(prevState) {
                if (prevState.actions.isGenerating) return null;

                return {
                    providerSelections: Object.assign({}, prevState.providerSelections, { data: result }),
                    form: Object.assign({}, prevState.form, {
                        referenceDate: result.referenceDate,
                        layout: result.layout,
                        frequency: result.frequency !== undefined ? result.frequency : 0,
                        version: result.version !== undefined ? result.version : "",
                        type: result.stopsSched ? 1 : 2,
                    }),
                    render: Object.assign({}, prevState.render, {
                        tab: result.stopsSched ? 1 : 2
                    })
                };
            },
            function() {
                var form = this.state.form;
                var edition = this.state.edition;

                edition.update(new Date(form.referenceDate));

                // Apply layout-driven render state
                this.applyLayoutSelected();

                // Load carris schedules
                this.state.commands.schedules.listCarris(
                    this.state.edition.planning,
                    function(res) {
                        this.onDataLoaded("carrisSchedules", "isLoadingSchedules", res, function() {
                            this.applyFilteredSchedules();
                        }.bind(this));
                    }.bind(this),
                    function(err) { this.onDataError("carrisSchedules", "isLoadingSchedules", err); }.bind(this)
                );

                // Load lines, then set form.line and load stops
                this.baseGenerator.getLines(
                    this.state,
                    function(res) {
                        this.onDataLoaded("lines", "isLoadingLines", res, function() {
                            this.onLinesReady();
                        }.bind(this));
                    }.bind(this),
                    function(err) { this.onDataError("lines", "isLoadingLines", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    onLinesReady() {
        this.setState(
            function(prevState) {
                var providerSelections = prevState.providerSelections;
                var preferredCode = (prevState.form && prevState.form.line && prevState.form.line.code) ? prevState.form.line.code : providerSelections.data.line;

                var line = prevState.data.lines.find(function(l) {
                    return l.code === preferredCode;
                });
                if (!line) return null;

                var newForm = Object.assign({}, prevState.form, { line: line });

                if (line.lastImportDate !== undefined) {
                    newForm.referenceDate = line.lastImportDate;
                    newForm.documentDate = line.lastImportDate;
                }

                if (
                    providerSelections.data.complementaryLines !== undefined &&
                    providerSelections.data.complementaryLines.length > 0
                ) {
                    newForm.complementaryLines = prevState.data.lines.filter(function(l) {
                        return providerSelections.data.complementaryLines.indexOf(l.code) !== -1;
                    });
                }

                return { form: newForm };
            },
            function() {
                if (this.state.form.line && this.state.form.line.lastImportDate !== undefined) {
                    this.state.edition.update(new Date(this.state.form.line.lastImportDate));
                }
                this.applySelectionsToCurrent();
                this.applyFilteredSchedules();
                this.loadStops();
            }.bind(this)
        );
    }

    loadStops() {
        var form = this.state.form;
        if (!form.line) return;

        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isLoadingStops: true }) };
            },
            function() {
                this.baseGenerator.getStops(
                    this.state,
                    function(result) {
                        this.onDataLoaded("stops", "isLoadingStops", result);
                    }.bind(this),
                    function(err) { this.onDataError("stops", "isLoadingStops", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    // Selection application
    // ----------------------

    applySelectionsToCurrent() {
        var computed = this.baseGenerator.computeSelectionExists(this.state, false);
        if (!computed) return;
        this.setState(computed);
    }

    applyLayoutSelected() {
        var computed = this.baseGenerator.computeLayoutSelected(this.state);
        this.setState(computed);
    }

    applyFilteredSchedules() {
        // Compute filtered schedules and immediately apply selection restoration atomically
        this.setState(function(prevState) {
            var partial = this.baseGenerator.computeFilteredSchedules(prevState);
            var merged = Object.assign({}, prevState, partial);
            var selection = this.baseGenerator.computeSelectionExists(merged, false);
            if (selection) {
                return Object.assign({}, partial, selection);
            }
            return partial;
        }.bind(this));
    }

    // User interactions
    // ----------------------

    handleLineChangeWithLayoutAwareness(selectedLine) {
        this.setState(
            function(prevState) {
                var newForm = Object.assign({}, prevState.form, { line: selectedLine !== null ? selectedLine : undefined });
                if (selectedLine !== null && selectedLine !== undefined && selectedLine.lastImportDate !== undefined) {
                    newForm.referenceDate = selectedLine.lastImportDate;
                    newForm.documentDate = selectedLine.lastImportDate;
                }
                return { form: newForm };
            },
            function() {
                if (this.state.form.line && this.state.form.line.lastImportDate !== undefined) {
                    this.state.edition.update(new Date(this.state.form.line.lastImportDate));
                }
                this.loadStops();
                if (this.state.form.layout && this.state.form.layout.id === -1) {
                    this.applyFilteredSchedules();
                }
            }.bind(this)
        );
    }

    onChangeValue(e, property) {
        var value = e.target.value;
        this.setState(function(prevState) {
            var newForm = Object.assign({}, prevState.form);
            newForm[property] = value;
            return { form: newForm };
        });
    }

    onSelectValue(e, property, callback) {
        this.setState(
            function(prevState) {
                var newForm = Object.assign({}, prevState.form);
                newForm[property] = e === null ? undefined : e;
                return { form: newForm };
            },
            function() {
                if (typeof callback === "function") {
                    callback();
                }
            }
        );
    }

    onChangeLayoutSelected() {
        this.setState(
            function(prevState) {
                return this.baseGenerator.computeLayoutSelected(prevState);
            }.bind(this),
            function() {
                if (this.state.form.layout && this.state.form.layout.id === -1) {
                    this.applyFilteredSchedules();
                } else {
                    this.applySelectionsToCurrent();
                }
            }.bind(this)
        );
    }

    onSelectAllSchedules(setOfDayTypesSchedules) {
        this.setState(function(prevState) {
            var ids = setOfDayTypesSchedules.map(function(s) { return s.id; });
            var current = Array.isArray(prevState.form.schedules) ? prevState.form.schedules : [];
            var allSelected = ids.every(function(id) { return current.indexOf(id) !== -1; });
            var newSchedules = allSelected
                ? current.filter(function(id) { return ids.indexOf(id) === -1; })
                : current.concat(ids.filter(function(id) { return current.indexOf(id) === -1; }));
            return { form: Object.assign({}, prevState.form, { schedules: newSchedules }) };
        });
    }

    onScheduleRowClick(scheduleId) {
        this.setState(function(prevState) {
            var schedules = Array.isArray(prevState.form.schedules) ? prevState.form.schedules.slice() : [];
            if (schedules.indexOf(scheduleId) !== -1) {
                schedules = schedules.filter(function(id) { return id !== scheduleId; });
            } else {
                schedules = schedules.concat([scheduleId]);
            }
            return { form: Object.assign({}, prevState.form, { schedules: schedules }) };
        });
    }

    onBaseScheduleRowClick(form, schedule, componentId, setOfDayTypesId, index) {
        this.setState(function(prevState) {
            var newForm = Object.assign({}, prevState.form);
            var objKey = newForm.line.code + "§" + componentId + "§" + newForm.type + "§" + setOfDayTypesId + "§" + index;

            if (newForm.schedules === undefined) {
                newForm.schedules = {};
            }

            var currentSchedules = Object.assign({}, newForm.schedules);
            if (!Array.isArray(currentSchedules[objKey])) {
                currentSchedules[objKey] = [];
            } else {
                currentSchedules[objKey] = currentSchedules[objKey].slice();
            }

            var schedIndex = currentSchedules[objKey].indexOf(schedule.id);
            if (schedIndex === -1) {
                currentSchedules[objKey].push(schedule.id);
            } else {
                currentSchedules[objKey].splice(schedIndex, 1);

                if (currentSchedules[objKey].length === 0) {
                    delete currentSchedules[objKey];
                }
            }

            newForm.schedules = currentSchedules;
            return { form: newForm };
        });
    }

    onBaseSelectAllSchedules(component, setOfDayTypesId) {
        this.setState(function(prevState) {
            var newForm = Object.assign({}, prevState.form);
            var objKey = newForm.line.code + "§" + component.componentId + "§" + newForm.type + "§" + setOfDayTypesId + "§" + component.index;

            var currentSchedules = Object.assign({}, newForm.schedules);
            if (!Array.isArray(currentSchedules[objKey])) {
                currentSchedules[objKey] = [];
            } else {
                currentSchedules[objKey] = currentSchedules[objKey].slice();
            }

            var remove = true;
            component.schedules.forEach(function(sched) {
                if (currentSchedules[objKey].indexOf(sched.id) === -1) {
                    remove = false;
                    currentSchedules[objKey].push(sched.id);
                }
            });

            if (remove) {
                component.schedules.forEach(function(sched) {
                    var idx = currentSchedules[objKey].indexOf(sched.id);
                    if (idx !== -1) {
                        currentSchedules[objKey].splice(idx, 1);
                    }
                });
            }

            newForm.schedules = currentSchedules;
            return {
                form: newForm,
                providerSelections: Object.assign({}, prevState.providerSelections, { search: false })
            };
        });
    }

    onStopRowClick(stop) {
        this.setState(function(prevState) {
            var stops = prevState.form.stops.slice();
            var index = stops.findIndex(function(s) { return s.code === stop.code; });
            if (index === -1) {
                stops.push(stop);
            } else {
                stops.splice(index, 1);
            }
            return { form: Object.assign({}, prevState.form, { stops: stops }) };
        });
    }

    onSelectAllStops() {
        this.setState(function(prevState) {
            var full = prevState.form.stops.length === prevState.data.stops.length;
            return {
                form: Object.assign({}, prevState.form, { stops: full ? [] : prevState.data.stops.slice() })
            };
        });
    }

    onSortChange(column) {
        this.setState(function(prevState) {
            var sort = Object.assign({}, prevState.sort);
            if (sort.column === column) {
                sort.order = sort.order === "ascending" ? "descending" : "ascending";
            } else {
                sort.column = column;
                sort.order = "ascending";
            }
            return { sort: sort };
        });
    }

    onChangeAlternativeText(e, dayType) {
        var value = e.target.value;
        this.setState(function(prevState) {
            var newAlt = Object.assign({}, prevState.render.alternativeText);
            newAlt[dayType] = value;
            return { render: Object.assign({}, prevState.render, { alternativeText: newAlt }) };
        });
    }

    onChangeReferenceDateValue(date) {
        this.setState(
            function(prevState) {
                return { form: Object.assign({}, prevState.form, { referenceDate: date }) };
            },
            function() {
                this.state.edition.update(new Date(date));
            }.bind(this)
        );
    }

    onChangeDocumentDateValue(date) {
        this.setState(function(prevState) {
            return { form: Object.assign({}, prevState.form, { documentDate: date }) };
        });
    }

    onChangeNotes(e, componentId) {
        var value = e.target.value;
        this.setState(function(prevState) {
            var newNotesComponents = prevState.render.notesComponents.map(function(c) {
                if (c.id === componentId) {
                    return Object.assign({}, c, { notes: value });
                }
                return c;
            });
            return {
                render: Object.assign({}, prevState.render, { notesComponents: newNotesComponents }),
                providerSelections: Object.assign({}, prevState.providerSelections, { search: false })
            };
        });
    }

    onExitMessage() {
        this.setState({
            message: { show: false, title: undefined, message: undefined, style: undefined, icon: undefined }
        });
    }

    // Download Files
    // ----------------------

    onDownloadClick(documentsToDownload) {
        const name = "Horários.zip";

        try {
            const newActions = Object.assign({}, this.state.actions);
            newActions.isDownloadingMultipleDocuments = true;
            this.setState({ actions: newActions });

            this.state.commands.download.downloadMultipleBusSched(
                documentsToDownload,
                '',
                (this.state.edition && this.state.edition.objects) ? this.state.edition.objects.network.id : '',
                (blob) => this.downloadSuccessCallback(blob, name, "isDownloadingMultipleDocuments"),
                (err) => this.errorCallback(err, "isDownloadingMultipleDocuments")
            );
        } catch (e) {
            console.error('Error:', e);
        }
    }

    async downloadSuccessCallback(blob, name, action) {
        try {
            const extension = name.split('.').pop();

            const fileHandle = await window.showSaveFilePicker({
                suggestedName: name,
                types: [{
                    description: `${extension.toUpperCase()} File`,
                    accept: { '*/*': [`.${extension}`] }
                }]
            });

            const writable = await fileHandle.createWritable();
            await writable.write(blob);
            await writable.close();
        } catch (e) {
            if (e.name !== 'AbortError') {
                // fallback to FileSaver if API not supported
                var FileSaver = require('file-saver');
                FileSaver.saveAs(blob, name);
            }
        }

        if (undefined !== action) {
            const { actions } = this.state;
            actions[action] = false;
            this.setState({ actions: actions });
        }
    }

    errorCallback(message, action) {
        const { actions } = this.state;
        actions[action] = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // Provider selections update
    // ----------------------

    updateProviderSelections() {
        var payload = this.baseGenerator.computeProviderSelectionsPayload(this.state);
        this.state.commands.providerSelections.updateCarris(
            payload,
            function(result) {
                if (!result) {
                    return;
                }

                this.setState(function(prevState) {
                    return { providerSelections: Object.assign({}, prevState.providerSelections, { data: result }) };
                });
            }.bind(this)
        );
    }

    // Generate
    // ----------------------

    onGenerateClick() {
        var form = this.state.form;
        var render = this.state.render;

        if (form.layout === undefined || form.layout === null) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar um layout.", style: "warning", icon: "alert" } });
            return;
        }

        if (form.line === undefined || form.line === null) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar uma linha.", style: "warning", icon: "alert" } });
            return;
        }

        var isScheduleNotSelected = Array.isArray(form.schedules)
            ? form.schedules.length === 0
            : Object.keys(form.schedules).length === 0;

        if (isScheduleNotSelected) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar pelo menos um horário.", style: "warning", icon: "alert" } });
            return;
        }

        if (form.type === 1 && form.stops.length === 0) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar pelo menos uma paragem.", style: "warning", icon: "alert" } });
            return;
        }

        if (form.layout.id === undefined || form.layout.id === null) {
            this.setState({ message: { show: true, title: "Aviso", message: "Layout selecionado inválido.", style: "warning", icon: "alert" } });
            return;
        }

        var commands = this.state.commands;

        var data = {
            line: form.line.id,
            lineId: form.line.id,
            schedules: form.schedules,
            referenceDate: form.referenceDate,
            hideLoopsChk: form.hideLoopsChk,
            frequency: form.frequency,
            documentDate: form.documentDate,
            type: form.type,
            colorType: form.colorType,
            version: form.version,
            componentSchedules: {},
            intervalComponentSchedules: {},
            alternateTexts: null,
        };

        this.setState(function(prevState) {
            return { actions: Object.assign({}, prevState.actions, { isGenerating: true }) };
        });

        var self = this;

        var onSuccess = function(a, result) {
            var parsedResult = null;
            try {
                parsedResult = JSON.parse(result);
            } catch (error) {
                console.error('Error parsing result:', error);
            }
            var documentsToDownload = parsedResult.map(item => item + ".svg");

            var onDownload = function () { self.onDownloadClick(documentsToDownload) };

            self.setState(function(prevState) {
                var msg = prevState.message.show ? prevState.message.message + "\n" + a : a;
                return {
                    actions: Object.assign({}, prevState.actions, { isGenerating: false }),
                    message: Object.assign({}, prevState.message, {
                        show: true,
                        message: msg,
                        style: "success",
                        title: "Sucesso",
                        icon: "ok",
                        downloadButtonText: onDownload ? "DOWNLOAD" : undefined,
                        onSecondary: onDownload
                    })
                };
            });
        };

        var onError = function(a) {
            self.setState(function(prevState) {
                var msg = prevState.message.show ? prevState.message.message + "\n" + a : a;
                return {
                    actions: Object.assign({}, prevState.actions, { isGenerating: false }),
                    message: { show: true, message: msg, style: "danger", title: "Erro", icon: "remove" }
                };
            });
        };

        switch (form.layout.id) {
            case -1:
                if (form.type === 1) {
                    data.stops = form.stops.map(function(stop) { return stop.id; });
                    var alternativeText = Object.values(render.alternativeText);
                    if (alternativeText.length > 0) {
                        data.alternateTexts = alternativeText;
                    }
                }
                this.updateProviderSelections();
                commands.draw.generateCarrisSched(data, onSuccess, onError);
                break;

            default:
                var validComponentIds = {};
                render.schedulesComponents.forEach(function(c) {
                    validComponentIds[String(c.componentId)] = true;
                });

                var cleanedSchedules = {};
                for (var cleanKey in form.schedules) {
                    if (validComponentIds[cleanKey.split("§")[1]]) {
                        cleanedSchedules[cleanKey] = form.schedules[cleanKey];
                    }
                }

                var cleanedForm = Object.assign({}, form, { schedules: cleanedSchedules });
                var cleanedState = Object.assign({}, this.state, { form: cleanedForm });

                for (var objKey in cleanedSchedules) {
                    var keyData = objKey.split("§");
                    var componentId = keyData[1];
                    var setId = keyData[3];
                    const index = keyData[4];

                    this.baseGenerator.filterAllowedSchedules(cleanedState, componentId, objKey);

                    if (data.componentSchedules[componentId] === undefined) {
                        data.componentSchedules[componentId] = {};
                    }
                    if (data.intervalComponentSchedules[componentId] === undefined) {
                        data.intervalComponentSchedules[componentId] = {};
                    }
                    if (data.intervalComponentSchedules[componentId][setId] === undefined) {
                        data.intervalComponentSchedules[componentId][setId] = {};
                    }
                    data.componentSchedules[componentId][setId] = cleanedSchedules[objKey];
                    data.intervalComponentSchedules[componentId][setId][index] = cleanedSchedules[objKey];
                }

                var providerPayload = this.baseGenerator.computeProviderSelectionsPayload(cleanedState);
                this.state.commands.providerSelections.update(
                    providerPayload,
                    function(result) {
                        if (!result) {
                            return;
                        }

                        self.setState(function(prevState) {
                            return {
                                providerSelections: Object.assign({}, prevState.providerSelections, { data: result }),
                                form: Object.assign({}, prevState.form, { schedules: cleanedSchedules })
                            };
                        });
                    }
                );

                if (form.type === 1) {
                    data.stops = form.stops;
                    commands.draw.generateBusSched(form.layout, data, onSuccess, onError);
                } else {
                    commands.draw.generateLineSched(form.layout, data, onSuccess, onError);
                }
                break;
        }
    }

    // Renders
    // ----------------------

    renderForm() {
        var data = this.state.data;
        var form = this.state.form;
        var render = this.state.render;
        var self = this;

        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLayout">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={function() { return "Sem Layouts Configurados"; }}
                                onChange={function(e) { self.onSelectValue(e, "layout", function() { self.onChangeLayoutSelected(); }); }}
                                options={render.layoutsGrouped.length > 0 ? render.layoutsGrouped : render.layouts}
                                isMulti={false}
                                isClearable={false}
                                getOptionValue={function(value) { return value.id; }}
                                getOptionLabel={function(label) { return label.name; }}
                                value={form.layout}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="formLine">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linha</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linha selecionada"
                                noOptionsMessage={function() { return "Sem Linhas Configurados"; }}
                                onChange={function(e) { self.handleLineChangeWithLayoutAwareness(e); }}
                                options={data.lines}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function(a) {
                                    return form.line === a.id;
                                }}
                                getOptionValue={function(value) { return value; }}
                                getOptionLabel={function(label) { return label.code + " | " + label.goName; }}
                                value={form.line}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="formReferenceDate">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.referenceDate}
                                placeholder="Data de Referência"
                                onChange={function(e) { self.onChangeReferenceDateValue(e); }} />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="formDocumentDate">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data do Documento</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="documentDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.documentDate}
                                placeholder="Data do Documento"
                                onChange={function(e) { self.onChangeDocumentDateValue(e); }} />
                        </Col>
                    </Row>
                </FormGroup>
                {form.layout !== undefined && form.layout.id === -1 ?
                    <FormGroup controlId="formFrequence">
                        <Row>
                            <Col sm={3} md={2}>
                                <ControlLabel className="padding-top-10">Frequência</ControlLabel>
                            </Col>
                            <Col sm={9} md={10}>
                                <FormControl type="number"
                                    min="1"
                                    value={form.frequency}
                                    placeholder="Introduza a frequência"
                                    onChange={function(e) { self.onChangeValue(e, "frequency"); }} />
                            </Col>
                        </Row>
                    </FormGroup>
                    : null
                }
                {form.layout !== undefined && form.layout.id !== -1 ?
                    <FormGroup controlId="formVersion">
                        <Row>
                            <Col sm={3} md={2}>
                                <ControlLabel className="padding-top-10">Versão</ControlLabel>
                            </Col>
                            <Col sm={9} md={10}>
                                <FormControl
                                    type="text"
                                    value={form.version}
                                    placeholder="Introduza a versão"
                                    onChange={function(e) { self.onChangeValue(e, "version"); }}
                                    onBlur={function(e) {
                                        var version = e.target.value;
                                        var isValid = /^[a-zA-Z0-9_-]*$/.test(version);
                                        if (!isValid) {
                                            self.setState({
                                                message: {
                                                    show: true,
                                                    title: "Aviso",
                                                    message: "A versão só pode conter letras, números, hifén (-) e sublinhado (_).",
                                                    style: "warning",
                                                    icon: "alert"
                                                }
                                            });
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    : null
                }
                <FormGroup controlId="formType">
                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Tipo de horário</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Radio key={1}
                                className="padding-top-7"
                                checked={form.type === 1}
                                onChange={function() { self.onSelectValue(1, "type"); }}
                                inline>
                                Horário de Paragem
                            </Radio>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Radio key={2}
                                className="padding-top-7 no-margin-left"
                                checked={form.type === 2}
                                onChange={function() {
                                    self.onSelectValue(2, "type", function() {
                                        self.setState(function(prevState) {
                                            var newRender = Object.assign({}, prevState.render);
                                            if (newRender.tab === 1) {
                                                newRender.tab = 2;
                                            }
                                            return { render: newRender };
                                        });
                                    });
                                }}
                                inline>
                                Horário de Linha
                            </Radio>
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="colorType">
                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Tipo de cor</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Radio key={1}
                                className="padding-top-7"
                                checked={form.colorType === 1}
                                onChange={function () { self.onSelectValue(1, "colorType"); }}
                                inline>
                                Cor Digital
                            </Radio>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Radio key={2}
                                className="padding-top-7 no-margin-left"
                                checked={form.colorType === 2}
                                onChange={function () {
                                    self.onSelectValue(2, "colorType", function () {
                                        self.setState(function (prevState) {
                                            var newRender = Object.assign({}, prevState.render);
                                            if (newRender.tab === 1) {
                                                newRender.tab = 2;
                                            }
                                            return { render: newRender };
                                        });
                                    });
                                }}
                                inline>
                                Cor Papel
                            </Radio>
                        </Col>
                    </Row>
                </FormGroup>
            </Grid>
        );
    }

    renderAlternativeText() {
        var render = this.state.render;
        var self = this;

        return (
            <div>
                {Object.keys(render.schedules).map(function(dayType, idx) {
                    return (
                        <Grid key={"day-type-schedules-" + idx} fluid>
                            <Row>
                                <Col sm={10} className="table-small-screens">
                                    <FormGroup controlId={"formNotes-" + dayType}>
                                        <ControlLabel>Texto Alternativo - {dayType}</ControlLabel>
                                        <FormControl
                                            componentClass="textarea"
                                            rows="3"
                                            className="notes-textarea"
                                            value={render.alternativeText[dayType]}
                                            placeholder="Sem tempos de passagem"
                                            onChange={function(e) { self.onChangeAlternativeText(e, dayType); }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Grid>
                    );
                })}
            </div>
        );
    }

    renderSetOfDayTypesRow(edition, schedules, form, dayType, idx) {
        if (schedules.length === 0) {
            return null;
        }

        var self = this;

        return (
            <Grid key={"day-type-schedules-" + idx} fluid>
                <Row>
                    <Col sm={2}>
                        <div className="margin-top-15 padding-top-7">
                            <div className="control-label">{dayType}</div>
                        </div>
                    </Col>
                    <Col sm={10} className="table-small-screens">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <ColumnResize className="columnResizer" />
                                    <th>Edição de Planeamento</th>
                                    <ColumnResize className="columnResizer" />
                                    <th>
                                        <Button
                                            bsSize="small"
                                            bsStyle="default"
                                            className="pull-right"
                                            onClick={function() { self.onSelectAllSchedules(schedules); }}>
                                            SELECIONAR TUDO
                                        </Button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {schedules.map(function(schedule, index) {
                                    return (
                                        <tr key={"sched-" + schedule.id}
                                            className={"busched selectable " + (Array.isArray(form.schedules) && form.schedules.indexOf(schedule.id) !== -1 ? "checked" : "")}
                                            onClick={function() { self.onScheduleRowClick(schedule.id); }}>
                                            <td>{schedule.name}</td>
                                            <td className="column_resizer_body" />
                                            <td colSpan={2}>{edition.getPlanningEditionName(schedule.planningEdition)}</td>
                                            <td className="column_resizer_body" />
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderSchedule(edition, form, component, schedule, index) {
        var self = this;
        return (
            <tr key={"sched-" + schedule.id}
                className={"busched selectable " + this.baseGenerator.getScheduleClassName(form, component.componentId, schedule, component.setOfDayTypesId, component.index)}
                onClick={function() { self.onBaseScheduleRowClick(form, schedule, component.componentId, component.setOfDayTypesId, component.index); }}>
                <td>{schedule.name}</td>
                <td>{edition.getPlanningEditionName(schedule.planningEdition)}</td>
                <td />
            </tr>
        );
    }

    renderComponentSchedules(edition, form, component) {
        var self = this;
        var componentLineSchedules = component.schedules
            .filter(function(schedule) { return schedule.lines.indexOf(form.line.id) !== -1; });

        if (!componentLineSchedules || componentLineSchedules.length === 0) {
            return (
                <tr className="busched">
                    <td colSpan={3}><span>Sem horários disponíveis para selecionar</span></td>
                </tr>
            );
        }

        return (
            <React.Fragment>
                {componentLineSchedules.map(function(schedule, index) {
                    return self.renderSchedule(edition, form, component, schedule, index);
                })}
            </React.Fragment>
        );
    }

    renderSchedulesTab(isLoadingSchedules) {
        if (isLoadingSchedules) {
            return <LoadingSpinner />;
        }

        var form = this.state.form;
        var render = this.state.render;
        var edition = this.state.edition;
        var self = this;

        if (form.line === undefined) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading><Panel.Title> Atenção </Panel.Title></Panel.Heading>
                    <Panel.Body>Linha não selecionada</Panel.Body>
                </Panel>
            );
        }

        if (form.layout === undefined) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading><Panel.Title> Atenção </Panel.Title></Panel.Heading>
                    <Panel.Body>Layout não selecionado</Panel.Body>
                </Panel>
            );
        }

        if ((render.schedulesComponents.length === 0 || render.setOfDayTypes.length === 0) && form.layout.id !== -1) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading><Panel.Title> Atenção </Panel.Title></Panel.Heading>
                    <Panel.Body>Tipos de dia não configurados no Layout</Panel.Body>
                </Panel>
            );
        }

        if (form.layout.id === -1) {
            if (Object.keys(render.schedules).length === 0) {
                return (
                    <Panel key="semLayout" className="margin-top-15">
                        <Panel.Heading><Panel.Title> Atenção </Panel.Title></Panel.Heading>
                        <Panel.Body>Sem horários disponíveis para selecionar</Panel.Body>
                    </Panel>
                );
            }

            return (
                <div>
                    {Object.keys(render.schedules).map(function(dayType, idx) {
                        return self.renderSetOfDayTypesRow(edition, render.schedules[dayType], form, dayType.toUpperCase(), idx);
                    })}
                </div>
            );
        }

        return (
            <div>
                {render.schedulesComponents.map(function(component, idx) {
                    return (
                        <Grid key={"day-type-schedules-" + idx} fluid>
                            <Row>
                                <Col sm={2}>
                                    {self.baseGenerator.renderSetOfDayTypesLabel(render.setOfDayTypes[idx], component)}
                                </Col>
                                <Col sm={10} className="table-small-screens">
                                    <Table responsive>
                                        <colgroup>
                                            <col style={{ width: '60%' }} />
                                            <col style={{ width: '30%' }} />
                                            <col style={{ width: 'auto' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Edição de Planeamento</th>
                                                <th>
                                                    <Button
                                                        bsSize="small"
                                                        bsStyle="default"
                                                        className="pull-right"
                                                        onClick={function() {
                                                            var setOfDayTypesId = render.setOfDayTypes[idx] === undefined ? 0 : render.setOfDayTypes[idx].id;
                                                            self.onBaseSelectAllSchedules(component, setOfDayTypesId);
                                                        }}>
                                                        SELECIONAR TUDO
                                                    </Button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {self.renderComponentSchedules(edition, form, component)}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Grid>
                    );
                })}
            </div>
        );
    }

    renderStopsTab() {
        var self = this;
        var state = this.state;

        return this.baseGenerator.renderStopsTab(
            state,
            function(column) { self.onSortChange(column); },
            function() { self.onSelectAllStops(); },
            function(stop) { self.onStopRowClick(stop); }
        );
    }

    renderBody() {
        var form = this.state.form;
        var render = this.state.render;
        var actions = this.state.actions;
        var self = this;

        if (form.line === undefined || form.line === null || form.layout === undefined || form.layout === null) {
            return null;
        }

        if (form.type === 2) {
            return (
                <Tabs defaultActiveKey={2} id="form-tabs">
                    <Tab eventKey={2} key="sched" title="Horários">
                        <Row>
                            <Col md={12} sm={12}>{this.renderSchedulesTab(actions.isLoadingSchedules)}</Col>
                        </Row>
                    </Tab>
                    {form.layout.id === -1
                        ? (
                            <Tab eventKey={3} key="notes" title="Texto Alternativo" className="padding-15">
                                {this.renderAlternativeText()}
                            </Tab>
                        )
                        : (
                            <Tab eventKey={3} key="notes" title="Observações" className="padding-15">
                                <Notes
                                    components={render.notesComponents}
                                    onChange={function(e, id) { self.onChangeNotes(e, id); }}
                                />
                            </Tab>
                        )}
                </Tabs>
            );
        }

        return (
            <Tabs defaultActiveKey={2} id="form-tabs">
                <Tab eventKey={2} key="sched" title="Horários">
                    <Row>
                        <Col md={6} sm={12}>{this.renderStopsTab()}</Col>
                        <Col md={6} sm={12}>{this.renderSchedulesTab(actions.isLoadingSchedules)}</Col>
                    </Row>
                </Tab>
                {form.layout.id === -1
                    ? (
                        <Tab eventKey={3} key="notes" title="Texto Alternativo" className="padding-15">
                            {this.renderAlternativeText()}
                        </Tab>
                    )
                    : (
                        <Tab eventKey={3} key="notes" title="Observações" className="padding-15">
                            <Notes
                                components={render.notesComponents}
                                onChange={function(e, id) { self.onChangeNotes(e, id); }}
                            />
                        </Tab>
                    )}
            </Tabs>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return <LoadingSpinner />;
        }

        return (
            <Grid fluid>
                <div className="margin-bottom-30">
                    {this.renderForm()}
                </div>
                {this.renderBody()}
            </Grid>
        );
    }

    render() {
        var actions = this.state.actions;
        var message = this.state.message;
        var self = this;

        return (
            <div>
                <TitleRow title="Gerar Horário" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={function() { self.onGenerateClick(); }}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderContent(actions.isLoadingLines || actions.isLoadingSetOfDayTypes)}
                {this.baseGenerator.renderGeneratingFeedback(actions.isGenerating)}
                {this.baseGenerator.renderEditionLoadingFeedback(actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={function() { self.onExitMessage(); }}
                    secondaryButtonText={message.downloadButtonText}
                    onSecondary={message.onSecondary} />
            </div>
        );
    }
}